define('services/navigator',["require", "exports", "plugins/router"], function (require, exports, router) {
    "use strict";
    function activeRoute() {
        var segments = router.activeInstruction().fragment.split("/");
        var route = segments[0];
        var path = segments[1];
        var area = router.activeInstruction().config.moduleId.split("/")[1];
        return new Route(route, path, area);
    }
    exports.activeRoute = activeRoute;
    function navigateTo(area, viewModel, route, param, query, title) {
        if (title === void 0) { title = null; }
        if (route != null) {
            if (route.indexOf("https") == -1 && route.indexOf("#") == -1) {
                var path = window.location.hash;
                if (path.indexOf("?") > -1) {
                    path = path.substr(0, path.indexOf("?"));
                }
                route = path + route;
            }
        }
        query = query || [];
        var schema = Tools.buildSchema(area, viewModel, route, param);
        var url = Tools.buildUrl(area, viewModel, route, param, query);
        if (!Tools.routeExists(schema)) {
            router.map([
                { route: schema, moduleId: area + "/viewmodels/" + viewModel, title: title || viewModel, nav: false }
            ]);
        }
        router.navigate(url);
    }
    exports.navigateTo = navigateTo;
    function navigateToUrl(url) {
        router.navigate(url);
    }
    exports.navigateToUrl = navigateToUrl;
    function goBack() {
        router.navigateBack();
    }
    exports.goBack = goBack;
    function navigateHome() {
        router.navigate("");
    }
    exports.navigateHome = navigateHome;
    var Tools = (function () {
        function Tools() {
        }
        Tools.routeExists = function (schema) {
            for (var index in router.routes) {
                var route = router.routes[index];
                if (route.route == schema) {
                    return true;
                }
            }
            ;
            return false;
        };
        Tools.buildSchema = function (area, viewModel, route, param) {
            var schema = route == null ? area + "/" + viewModel : route;
            if (param != null) {
                schema += "/" + param; // "/:path";  => reworked, now directlinks to apps are possible
            }
            if (schema.indexOf("#") > -1)
                schema = schema.replace("#", "");
            return schema;
        };
        Tools.buildUrl = function (area, viewModel, route, param, query) {
            var url = route == null ? area + "/" + viewModel : route;
            if (param != null) {
                url += "/" + param;
            }
            if (query.length > 0) {
                url += "?";
                query.forEach(function (param) {
                    url += "&" + param.key + "=" + param.value;
                });
            }
            return url.replace("?&", "?");
        };
        return Tools;
    }());
    var NavigationParameter = (function () {
        function NavigationParameter(key, value) {
            this.key = key;
            this.value = value;
        }
        return NavigationParameter;
    }());
    exports.NavigationParameter = NavigationParameter;
    var Route = (function () {
        function Route(route, path, area) {
            this.route = route;
            this.path = path;
            this.area = area;
        }
        return Route;
    }());
    exports.Route = Route;
});

